import { Entry } from '../Entry'

export function Entry20230728() {
  return (
    <Entry title="Jul 28 2023 - v3.4.8">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13976/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
